import { extract } from '../extractors/marketVolume';
import { fmtUSD, fmtPct } from '../extractors/_shared';

const txt = (lang, zh, en) => (lang === 'en' ? en : zh);

export function getMarketVolumeEvidence(project, _a, lang = 'zh') {
  const d = extract(project);
  if (!d) return [];
  const rows = [];
  if (d.totalVolume != null)
    rows.push({ label: txt(lang, '全市场24h成交', 'Market 24h Vol'), val: fmtUSD(d.totalVolume), source: 'CoinGecko' });
  if (d.binanceVolume != null && d.binanceVolume > 0)
    rows.push({ label: txt(lang, 'Binance 24h', 'Binance 24h'), val: fmtUSD(d.binanceVolume), source: 'CoinGecko' });
  if (d.cexShare != null)
    rows.push({ label: txt(lang, 'CEX 占比', 'CEX Share'), val: fmtPct(d.cexShare), source: 'CoinGecko' });
  return rows;
}

export function MarketVolumeCard({ project, lang = 'zh', S, C }) {
  const d = extract(project);
  if (!d) return null;

  const barColors = { cex: '#3b82f6', dex: '#10b981' };

  return (
    <div style={S?.card || { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 12 }}>
      <div style={{ fontSize: 10, fontWeight: 700, color: C?.muted || '#6b7280', marginBottom: 10, textTransform: 'uppercase' }}>
        💱 {txt(lang, '全市场交易数据 (24h)', 'Market Trading Data (24h)')}
        <span style={{ marginLeft: 8, fontWeight: 400, fontSize: 9, color: '#94a3b8' }}>CoinGecko · {d.tickerCount} {txt(lang, '个交易对', 'pairs')}</span>
      </div>

      {/* KPI 三列：全市场 / Binance / CEX 占比 */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 12 }}>
        <div>
          <div style={{ fontSize: 10, color: C?.muted || '#6b7280' }}>{txt(lang, '总成交', 'Total Vol')}</div>
          <div style={{ fontSize: 14, fontWeight: 700 }}>{fmtUSD(d.totalVolume)}</div>
        </div>
        <div>
          <div style={{ fontSize: 10, color: C?.muted || '#6b7280' }}>{txt(lang, 'Binance', 'Binance')}</div>
          <div style={{ fontSize: 14, fontWeight: 700, color: d.binanceVolume > 0 ? '#f59e0b' : (C?.muted || '#6b7280') }}>
            {d.binanceVolume > 0 ? fmtUSD(d.binanceVolume) : '—'}
          </div>
          {d.binanceShare > 0 && (
            <div style={{ fontSize: 9, color: C?.muted || '#6b7280' }}>{fmtPct(d.binanceShare)} {txt(lang, '占比', 'share')}</div>
          )}
        </div>
        <div>
          <div style={{ fontSize: 10, color: C?.muted || '#6b7280' }}>{txt(lang, 'CEX / DEX', 'CEX / DEX')}</div>
          <div style={{ fontSize: 14, fontWeight: 700 }}>{fmtPct(d.cexShare)} / {fmtPct(1 - d.cexShare)}</div>
        </div>
      </div>

      {/* CEX vs DEX 占比条 */}
      {(d.cexTotal > 0 || d.dexTotal > 0) && (
        <div style={{ marginBottom: 12 }}>
          <div style={{ display: 'flex', height: 6, borderRadius: 3, overflow: 'hidden', background: '#f3f4f6' }}>
            <div style={{ width: `${(d.cexShare * 100).toFixed(1)}%`, background: barColors.cex }} title={`CEX ${fmtUSD(d.cexTotal)}`} />
            <div style={{ width: `${((1 - d.cexShare) * 100).toFixed(1)}%`, background: barColors.dex }} title={`DEX ${fmtUSD(d.dexTotal)}`} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 9, color: C?.muted || '#6b7280', marginTop: 4 }}>
            <span><span style={{ display: 'inline-block', width: 8, height: 8, background: barColors.cex, borderRadius: 2, marginRight: 4 }} />CEX {fmtUSD(d.cexTotal)}</span>
            <span>DEX {fmtUSD(d.dexTotal)}<span style={{ display: 'inline-block', width: 8, height: 8, background: barColors.dex, borderRadius: 2, marginLeft: 4 }} /></span>
          </div>
        </div>
      )}

      {/* Top 5 交易所 */}
      {d.topExchanges.length > 0 && (
        <div>
          <div style={{ fontSize: 10, fontWeight: 700, color: C?.muted || '#6b7280', marginBottom: 6, textTransform: 'uppercase' }}>
            {txt(lang, 'Top 5 交易场所', 'Top 5 Venues')}
          </div>
          <table style={{ width: '100%', fontSize: 11, borderCollapse: 'collapse' }}>
            <tbody>
              {d.topExchanges.map((e, i) => (
                <tr key={i} style={{ borderBottom: `1px solid ${C?.faint || '#f3f4f6'}` }}>
                  <td style={{ padding: '4px 6px' }}>
                    <span style={{ fontWeight: 600 }}>{e.name}</span>
                    <span style={{ marginLeft: 6, fontSize: 9, color: e.isDex ? barColors.dex : barColors.cex, fontWeight: 600 }}>
                      {e.isDex ? 'DEX' : 'CEX'}
                    </span>
                  </td>
                  <td style={{ padding: '4px 6px', textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{fmtUSD(e.volume)}</td>
                  <td style={{ padding: '4px 6px', textAlign: 'right', color: C?.muted || '#6b7280', fontVariantNumeric: 'tabular-nums', width: 50 }}>{fmtPct(e.share)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
